import React, {useEffect, useState} from "react";
import {Slider} from "@blueprintjs/core";

/**
 * Slider selector for the contract length (number of monthly installments).
 * Mirrors the look of FeeSlider (opłata wstępna / wykup) but snaps to the
 * discrete list of allowed lengths by sliding over their indexes — so it works
 * regardless of the spacing between the allowed values.
 */
function ContractLengthSlider(props) {

    const items = (props.items && props.items.length) ? props.items : [];

    const valueToIndex = (val) => {
        const i = items.indexOf(val);
        return i >= 0 ? i : Math.max(0, items.length - 1);
    };

    const snapToNearest = (val) => {
        if (!items.length) return val;
        return items.reduce((best, cur) =>
            Math.abs(cur - val) < Math.abs(best - val) ? cur : best, items[0]);
    };

    const [index, setIndex] = useState(valueToIndex(props.value));
    const [inputValue, setInputValue] = useState(props.value);

    useEffect(() => {
        setIndex(valueToIndex(props.value));
        setInputValue(props.value);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.value, props.items]);

    const handleChange = (newIndex) => {
        setIndex(newIndex);
        if (items[newIndex] !== undefined) setInputValue(items[newIndex]);
    };

    const handleRelease = (newIndex) => {
        const chosen = items[newIndex];
        if (chosen !== undefined) props.onChange(chosen);
    };

    const inputChangeHandler = (e) => setInputValue(e.target.value);

    const inputBlurHandler = () => {
        const parsed = parseInt(inputValue, 10);
        const snapped = isNaN(parsed) ? items[index] : snapToNearest(parsed);
        setInputValue(snapped);
        setIndex(valueToIndex(snapped));
        props.onChange(snapped);
    };

    const labelStr = typeof props.label === "string" ? props.label : "";
    const parenIdx = labelStr.indexOf("(");
    const title = parenIdx >= 0 ? labelStr.slice(0, parenIdx).trim() : labelStr;
    const subtitle = parenIdx >= 0 ? labelStr.slice(parenIdx) : null;

    return (
        <div className="calc__form-item">
            <div className="calc__fee-header">
                <p className="calc__form-label calc__period-label">
                    <span className="calc__period-title">{title}</span>
                    {subtitle && <span className="calc__period-subtitle"> {subtitle}</span>}
                </p>
                <div className="calc__fee-input">
                    <input type="number"
                           className="calc__period-input"
                           value={inputValue}
                           onChange={inputChangeHandler}
                           onBlur={inputBlurHandler}
                           onKeyDown={e => { if (e.key === "Enter") e.target.blur(); }}/>
                    <span className="calc__fee-unit">mies.</span>
                </div>
            </div>
            <Slider
                min={0}
                max={Math.max(0, items.length - 1)}
                stepSize={1}
                labelRenderer={false}
                value={index}
                className="go-slider"
                onChange={handleChange}
                onRelease={handleRelease}
            />
        </div>
    );
}

export default ContractLengthSlider;
